var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddStudent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 10.6667C21.6133 10.6667 24 8.28 24 5.33333C24 2.38667 21.6133 0 18.6667 0C15.72 0 13.3333 2.38667 13.3333 5.33333C13.3333 8.28 15.72 10.6667 18.6667 10.6667ZM6.66667 8V5.33333C6.66667 4.6 6.06667 4 5.33333 4C4.6 4 4 4.6 4 5.33333V8H1.33333C0.6 8 0 8.6 0 9.33333C0 10.0667 0.6 10.6667 1.33333 10.6667H4V13.3333C4 14.0667 4.6 14.6667 5.33333 14.6667C6.06667 14.6667 6.66667 14.0667 6.66667 13.3333V10.6667H9.33333C10.0667 10.6667 10.6667 10.0667 10.6667 9.33333C10.6667 8.6 10.0667 8 9.33333 8H6.66667ZM18.6667 13.3333C15.1067 13.3333 8 15.12 8 18.6667V20C8 20.7333 8.6 21.3333 9.33333 21.3333H28C28.7333 21.3333 29.3333 20.7333 29.3333 20V18.6667C29.3333 15.12 22.2267 13.3333 18.6667 13.3333Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddStudent);
export default __webpack_public_path__ + "static/media/icon_add_student.84b670a2b41dc55de41baed837495368.svg";
export { ForwardRef as ReactComponent };